import { store } from "@betacrew/jars-flux"

export const componentKey = 'RECOMMEND_FORM'

const initialReducerState = {
    guidedFormList: [],
    loadingState: false
}

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setGuidedFormList: (state, action) => {
            state.guidedFormList = action.payload
        },
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
    },
    initialReducerState
})

export const { setGuidedFormList, setLoadingState } = actions